<div class="container mt-4">
  <div class="row">
    <app-sidebar class="col-12 col-md-3"></app-sidebar>

    <div class="col mt-4 mt-md-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
